import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Hilton Auto Spare Parts Management System. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

